module.exports = __webpack_public_path__ + "static/media/icon_google-play.55cefdae.svg";